<h2 mat-dialog-title>{{ editBusStopData.id ? 'Edit bus stop' : 'New bus stop' }}</h2>

<mat-dialog-content class="editBusStopData-dialog-content">
  <form #editBusStopDataForm="ngForm">

    <div class="form-row">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Name</mat-label>
        <input matInput [(ngModel)]="editBusStopData.name" name="name" required>
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Description</mat-label>
        <textarea matInput [(ngModel)]="editBusStopData.description" name="description" rows="2"></textarea>
      </mat-form-field>
    </div>

    <div class="form-row two-columns">
      <mat-form-field appearance="outline">
        <mat-label>Address</mat-label>
        <input matInput [(ngModel)]="editBusStopData.address" name="address">
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>City</mat-label>
        <input matInput [(ngModel)]="editBusStopData.city" name="city">
      </mat-form-field>
    </div>

    <div class="form-row two-columns">
      <mat-form-field appearance="outline">
        <mat-label>Postal code</mat-label>
        <input matInput [(ngModel)]="editBusStopData.cp" name="cp">
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>District</mat-label>
        <input matInput [(ngModel)]="editBusStopData.district" name="district">
      </mat-form-field>
    </div>

    <div class="form-row two-columns">
      <mat-form-field appearance="outline">
        <mat-label>Direction</mat-label>
        <input matInput [(ngModel)]="editBusStopData.direction" name="direction">
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Type</mat-label>
        <mat-select [(ngModel)]="editBusStopData.type" name="type">
          <mat-option value="urban">Urban</mat-option>
          <mat-option value="interurban">Interurban</mat-option>
          <mat-option value="shelter">Shelter</mat-option>
          <mat-option value="pole">Pole only</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Mapa Leaflet: alimenta lat/long -->
    <div class="form-row">
      <label class="map-label">Location</label>
      <div id="map" class="map-frame"></div>
      <div class="coords-readout">
        <span>Lat: {{ editBusStopData.lat || '—' }}</span>
        <span>Long: {{ editBusStopData.long || '—' }}</span>
      </div>
    </div>

    <div class="form-row two-columns">
      <mat-form-field appearance="outline">
        <mat-label>Routes served</mat-label>
        <input matInput type="number" [(ngModel)]="editBusStopData.routes_served" name="routes_served">
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Daily passengers</mat-label>
        <input matInput type="number" [(ngModel)]="editBusStopData.daily_passengers" name="daily_passengers">
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Amenities</mat-label>
        <input matInput [(ngModel)]="editBusStopData.amenities" name="amenities">
      </mat-form-field>
    </div>

    <div class="form-row two-columns">
      <mat-form-field appearance="outline">
        <mat-label>Installation date</mat-label>
        <input matInput [matDatepicker]="installPicker" [(ngModel)]="editBusStopData.installation" name="installation">
        <mat-datepicker-toggle matSuffix [for]="installPicker"></mat-datepicker-toggle>
        <mat-datepicker #installPicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Last inspection</mat-label>
        <input matInput [matDatepicker]="inspectionPicker" [(ngModel)]="editBusStopData.last_inspection" name="last_inspection">
        <mat-datepicker-toggle matSuffix [for]="inspectionPicker"></mat-datepicker-toggle>
        <mat-datepicker #inspectionPicker></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Maintained by</mat-label>
        <input matInput [(ngModel)]="editBusStopData.maintainded" name="maintainded">
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Notes</mat-label>
        <textarea matInput [(ngModel)]="editBusStopData.notes" name="notes" rows="3"></textarea>
      </mat-form-field>
    </div>

  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Cancel</button>
  <button mat-raised-button color="primary" (click)="desar()" [disabled]="!editBusStopDataForm.valid">Save</button>
</mat-dialog-actions>